import React, {useMemo} from "react";
import clsx from "clsx";

export default function Pagination({payload, onPageChange}) {
    const pages = useMemo(() => {
        let temp = [];
        for(let i=1; i<=payload.last_page; i++) {
            temp[i] = {
                id: i,
                active: i == payload.page,
            };
        }
        const pages = temp.map(node =>
            <li key={node.id} className={clsx('page-item', {'active': node.active})}>
                <a
                    href="#"
                    className="page-link"
                    data-page={node.id}
                    data-active={node.active}
                    onClick={(e) => {onPageChange(e)}}
                >
                    {node.id}
                </a>
            </li>
        );
        return pages;
    }, [payload]);

    return <div className="d-flex flex-stack flex-wrap pt-10">
        <div className="fs-6 fw-semibold text-gray-700">
            Showing {payload.from} to {payload.total > payload.to ? payload.to : payload.total} of {payload.total} entries
        </div>

        <ul className="pagination">
            <li className="page-item previous">
                <a href="#" className="page-link" data-page={payload.page-1 > 0 ? payload.page-1 : 1} onClick={(e) => {onPageChange(e)}}><i className="previous"></i></a>
            </li>

            {pages}

            <li className="page-item next">
                <a href="#" className="page-link" data-page={payload.page+1 < payload.last_page ? payload.page+1 : payload.last_page} onClick={(e) => {onPageChange(e)}}><i className="next"></i></a>
            </li>
        </ul>
    </div>
}